import script from "./SearchAndFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAndFilters.vue?vue&type=script&setup=true&lang=ts"

import "./SearchAndFilters.vue?vue&type=style&index=0&id=1ffdecc1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffdecc1"]])

export default __exports__